export const INCOMING_MESSAGE_TYPES = {
    experimentDataProvided: 'experimentDataProvided',
} as const;

function quitGame() {
    parent.postMessage({ type: 'quit' }, '*');
}

function requestExperimentData(flag: string) {
    parent.postMessage(
        {
            type: 'experimentDataRequested',
            payload: {
                flag,
            },
        },
        '*',
    );
}

function notifyExperimentExposure(flag: string) {
    parent.postMessage(
        {
            type: 'experimentExposed',
            payload: {
                flag,
            },
        },
        '*',
    );
}

export const parentApi = {
    quitGame,
    requestExperimentData,
    notifyExperimentExposure,
};
